// extracted by mini-css-extract-plugin
export var active = "_m8-e";
export var blink = "_m8-f";
export var dropDownSelector = "_m8-5";
export var dropDownWrapper = "_m8-4";
export var fakeCursor = "_m8-d";
export var fontSizeButton = "_m8-7";
export var formQuillEditor = "_m8-0";
export var pressed = "_m8-g";
export var qlBlank = "_m8-1";
export var textFormattingToolbar = "_m8-2";
export var textFormattingToolbarClosed = "_m8-3";
export var textFormattingToolbarInline = "_m8-6";
export var textToolbarOption = "_m8-8";
export var toolbarCell = "_m8-a";
export var toolbarCellCollapsed = "_m8-b";
export var toolbarOptionHitArea = "_m8-c";
export var toolbarOverflow = "_m8-9";